<template>
  <div class="container">
    <h1>Welcome to Cereal City Science Online</h1>

      <div class="inputs">
        <h3 style="text-align: center; margin-bottom: 15px;">Please create an account using your district access code.</h3>
        <p style="margin: 15px; margin-bottom: 0;">If you don't have an access code and your district uses the Cereal City Science curriculum, please contact your district coordinator to get your access code. If you're a district coordinator and you need your district's access code or if you would like to purchase curriculum in order to use the Cereal City Science Online platform, please contact Suzan Luther at suzan@bcamsc.org or call (269) 213-3904.</p>
        <div class="create-account-input">
          <p class="msg"> <span v-if="codeMsg" >{{ codeMsg }}</span></p>
          <label for="districtCode"></label>
          <input type="text" v-model="districtCode" id="districtCode" @blur="checkCode" placeholder="District Access Code" required>
          <p class="tiny-text">Hint: letters only - no numbers, spaces, or punctuation.</p>
        </div>
        <div class="create-account-input">
          <label for="email"></label>
          <input type="email" id="email" v-model="userEmail" placeholder="Email" required>
        </div>
        <div class="create-account-input">
          <label for="password"></label>
          <input type="password" id="password" v-model="userPassword" placeholder="Password (must be at least 6 characters)" required>
        </div>
        <div class="create-account-input">
          <label for="password02"></label>
          <input type="password" id="password02" placeholder="Confirm Password" required>
        </div>
        <div class="create-account-input">
          <label for="firstName"></label>
          <input type="text" id="firstName" v-model="userFirstName" placeholder="First Name" required>
        </div>
        <div class="create-account-input">
          <label for="lastName"></label>
          <input type="text" id="lastName" v-model="userLastName" placeholder="Last Name" required>
        </div>
        <div class="create-account-buttons">
          <p> </p>
          <button @click.prevent="createUser" :disabled="isDisabled || !districtCode">Create Account</button>
          <p> </p>
        </div>
      </div>

    <p>Already have an account? <a href="/">Please login.</a></p>
  </div>
</template>

<script>
const fb = require('./../firebase/firebase')
import { mapState } from 'vuex'

export default {
  name: 'Home',
  data() {
    return {
      districtCode: null,
      districtCodeValid: false,
      districtId: '',
      districtName: '',
      districtCity: '',
      districtState: '',
      userRole: 'teacher',
      userFirstName: '',
      userLastName: '',
      userEmail: '',
      userPassword: '',
      active: true,
      codeMsg: null,
      isDisabled: true
    }
  },
  computed: {
    ...mapState([ 'userProfile' ])
  },
  methods: {
    checkCode() {
      this.codeMsg = null
      if (this.districtCode) {
        this.districtCode = this.districtCode.toUpperCase()
        fb.districtCodesCollection.doc(this.districtCode).get().then((doc) => {
          if (doc.exists && doc.data().status == 'assigned') {
            console.log(this.districtCode)
            console.log(doc.data().status)
            this.districtCodeValid = true
            this.isDisabled = false
          } else {
            this.districtCodeValid = false
            this.isDisabled = true
            this.codeMsg = '** Please enter a valid District Access Code. **'
          }
        }).then(() => {
          this.fetchDistrictFromCode()
        })
      }
    },
    fetchDistrictFromCode() {
      fb.districtsCollection.where("districtCode", "==", this.districtCode).get().then((snap) => {
        snap.forEach((doc) => {
          this.districtId = doc.id
          this.districtName = doc.data().districtName
          this.districtCity = doc.data().districtCity
          this.districtState = doc.data().districtState
        })
      })
    },
    createUser() {
      fb.auth.createUserWithEmailAndPassword(this.userEmail, this.userPassword).then((data) => {
        fb.usersCollection.doc(data.user.uid).set({
          userId: data.user.uid,
          districtId: this.districtId,
          districtCode: this.districtCode,
          districtName: this.districtName,
          districtCity: this.districtCity,
          districtState: this.districtState,
          userRole: this.userRole,
          userFirstName: this.userFirstName,
          userLastName: this.userLastName,
          userEmail: this.userEmail,
          active: this.active,
          signupDate: new Date()
        }).then(() => {
          this.$store.commit('SET_CURRENT_USER', data.user)
          this.$store.dispatch('fetchUserProfile')
          this.$router.push('/dashboard')
        })
      })
    }
  },
  mounted() {
    console.log('mounted', this.userProfile)
    if (this.userProfile) {
      this.$router.push('/dashboard')
    }
  }
}
</script>

<style lang="css" scoped>
.msg {
  color: darkOrange;
  text-align: center;
}
.inputs {
  display: table;
  text-align: left;
  max-width: 600px;
  background-color: #f7f7f7;
  border: 1px solid #cecece;
  border-radius: 7px;
  margin: auto;
  margin-top: 15px;
  padding: 30px;
  box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;
}
input {
  border: 1px solid #cecece;
  border-radius: 5px;
  background-color: white !important;
  height: 40px;
  max-width: 600px;
  padding: 10px;
  margin: 5px;
}
.inputs02 {
  margin: 10px auto;
  padding: 20px;
  max-width: 600px;
  border: 1px solid grey;
  text-align: left;
}
.create-account-input {
  display: grid;
  grid-template-columns: 1fr;
  margin-bottom: 20px;
}
.create-account-buttons {
  display: grid;
  grid-template-columns: 1fr auto 1fr;
  margin-bottom: 20px;
}
.tiny-text {
  margin: 15px;
  margin-top: 0;
  margin-bottom: 0;
  font-size: .85em;
  color: darkOrange;
}
button {
  height: 40px;
  width: 300px;
  margin: 5px;
  color: white;
  background-color: #f47e20;
  border: none;
  border-radius: 5px;
  font-size: 1.2em;
  font-weight: 600;
  cursor: pointer;
}
button:disabled {
  background-color: #888;
  cursor: not-allowed;
}
</style>
